import React, { Component } from 'react';
import L from 'leaflet';
import {db} from './../firebase/firebase.js'
// import marker from './marker.png';
import getUserLoc, {defaultPos} from './../utils/location.js'
import geo from 'html5-geolocation'
import './../App.css'
// var markerIcon = L.icon({
//     iconUrl:'./marker.png',
//     iconSize: [25,25],
// });

class Map extends Component {
    constructor(props){
        super(props)
        this.state = {
            mapObject: null,
            events: [],
            userPos: {coords: {latitude: 32.88535, longitude: -117.23981}}
        }
    }

    componentDidMount() {
        // get user loc
        geo().on('position', (position) => {

            this.setState({userPos: position})
        })
        .on('error', (error) => {
            // this.setState({})
        })
        .highAccuracy(true)
        .watch()
        // load all events
        db.collection("events") // TODO: change to events
            .orderBy('eventEnd', 'desc')
            .limit(100).get().then(snapshot => {
                snapshot.forEach(doc => {
                    let data = doc.data()
                    data.uid = doc.id
                    this.state.events.push(data)
                    this.setState({
                        "events" : this.state.events
                    })
                    // console.log(this.state.events)
                })
            })
            .catch(err => {
              // console.log('Error getting documents', err);
            });

        // create map object

        let mapObject = L.map('mapid').setView([this.state.userPos.coords.latitude,this.state.userPos.coords.longitude], 20)
        
        L.tileLayer(
            'https://api.tiles.mapbox.com/v4/{id}/{z}/{x}/{y}.png?access_token={accessToken}', 
            {
            attribution: 'Map data &copy; <a href="https://www.openstreetmap.org/">OpenStreetMap</a> contributors, <a href="https://creativecommons.org/licenses/by-sa/2.0/">CC-BY-SA</a>, Imagery © <a href="https://www.mapbox.com/">Mapbox</a>',
            maxZoom: 18,
            id: 'mapbox.streets',
            accessToken: 'pk.eyJ1IjoiY2FpY3V0ZWMiLCJhIjoiY2puN3NnYnVtMW90YzN3cW9haW15ejh5OSJ9.Vsc6SoPIYFYdDB9iIoDrWA',
        }).addTo(mapObject);
        // var mymarker = L.marker([32.88535,-117.23981]).addTo(mapObject);
        // mymarker.bindPopup(
        //     "<b>its food<br>lat & long:</b><br>" + 
        //     32.88535 + " " + -117.23981).openPopup();

        // change to this.state.events.forEach
        // console.log("cooords")
        // console.log([this.state.userPos.coords.latitude, this.state.userPos.coords.longitude])//[location.latitude, location.longitude])
        let icon = L.icon({
            iconUrl: "https://image.flaticon.com/icons/png/512/10/10611.png",
            iconSize: [80,80]
        })
        L.marker([this.state.userPos.coords.latitude, this.state.userPos.coords.longitude], {icon: icon}).addTo(mapObject)//[location.latitude, location.longitude], {radius: 200}).addTo(map);

        
        this.setState({
                mapObject: mapObject
            }
        )
    }

    createMarker(tags, location, uid, mapObject, endDate){
         // console.log(this.state.userPos)

        // map each tag to the emoji
        let t = new Set(tags)
        let filePath = 'https://ronakshah.net/racoon/src/assets/'
        if (t.has("#freeFood")) {
            filePath += 'Food'
        }
        if (t.has("#freeMusic")) {
            filePath += 'Music'
        }
        if (t.has("#freeSwag")) {
            filePath += 'Swag'
        }
        filePath += "40x40.png"
        let coords = [location.latitude, location.longitude]
        // console.log(coords)
        let icon = L.icon({
            iconUrl: filePath,
            iconSize: [80,80],
        })
        console.log(endDate)
        let timeLeft = new Date() - new Date(endDate.seconds)
        console.log(timeLeft)
        timeLeft = new Date(timeLeft)
        // console.log(mapObject)
        L.marker(coords, {icon: icon}).addTo(this.state.mapObject).bindPopup(
            `${tags.join(', ')}\n\nEnds in ${timeLeft.getHours()} hours`)
    }

    render() {
        this.state.events.forEach((event) => { 
            console.log(event)      
            this.createMarker(event.tags,
                event.location,
                event.uid,
                this.state.mapObject, event.eventEnd)
        });
        return(
            <div id="map-container">
                <div id="mapid" >
                <link rel="stylesheet" 
                    href="https://cdnjs.cloudflare.com/ajax/libs/leaflet/0.7.7/leaflet.css">
                    </link>
                </div>
            </div>
        );
    }      
}


export default Map;